// Local inline-SVG image placeholders.
// Avoids slow/failing external services like via.placeholder.com (which was
// returning 502s and blocking page load on every broken image).

export function placeholderImage(width = 150, height = width, text = "Image") {
  const w = Number(width) || 150;
  const h = Number(height) || w;
  const label = String(text).replace(/[<>&]/g, "");
  const fontSize = Math.max(12, Math.round(Math.min(w, h) / 8));
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">
    <rect width="100%" height="100%" fill="#e2e8f0"/>
    <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle"
      font-family="Arial, sans-serif" font-size="${fontSize}" fill="#94a3b8">${label}</text>
  </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

// onError handler that swaps to a local placeholder once, preventing
// infinite onError loops when the fallback itself fails.
export function imgErrorFallback(e, width, height, text) {
  const el = e?.currentTarget || e?.target;
  if (!el || el.dataset.fallbackApplied) return;
  el.dataset.fallbackApplied = "1";
  el.src = placeholderImage(width, height, text);
}
